const handleFilterEnable = (filter) => (e, availableFilters) => {
    const $filter = $(filter);
    // reset all filter options
    $(filter).find('input[type="checkbox"]:not([data-no-input-disable])').prop('disabled', true);

    Object.entries(availableFilters).forEach(([filterName, options]) => {
        const $field = $filter.find(`fieldset[name="${filterName}"]`);
        options.forEach(
            option => $field.find(`[id="${filterName}-${option}"]`).prop('disabled', false)
        );
    });
};

export default handleFilterEnable;



// WEBPACK FOOTER //
// ./src/scripts/components/filter/handleFilterEnable.js